module.exports = __webpack_public_path__ + "static/media/wasafat_tabkh_image_presentation.dbcdaec9.png";